<template>
  <div>
    <div class="show-box-bg wx-login-box">
      <div class="conten">
        <div class="titl"></div>
        <div class="spacing">
          <div class="title-prompt">
            <el-divider border-color="#2489FD" content-position="center">
              欢迎登录
            </el-divider>
          </div>
          <el-form
            :model="loginForm"
            :rules="LoginFormRules"
            ref="loginFormRef"
            class="demo-ruleForm"
          >
            <el-form-item label="" prop="name">
              <el-input
                type="text"
                v-model="loginForm.name"
                maxlength="20"
                @input="handleChange"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="memberPassword">
              <el-input
                placeholder="密码"
                v-model="loginForm.memberPassword"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <button
                class="subutt"
                type="button"
                @click="submitForm(loginForm)"
              >
                登 录
              </button>
            </el-form-item>
          </el-form>
          <div class="greement">
            <el-checkbox v-model="checked"></el-checkbox> 您登录即默认同意<span
              @click="jumpDetails(6)"
              >《用户协议》</span
            >
            及 <span @click="jumpDetails(7)">《隐私协议》</span>
          </div>
          <div class="close">
            <i
              style="color: #7a7b7b"
              class="el-icon-circle-close"
              @click="getSchoolName(schoolName)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/Login";
export default {
  name: "StudentVue",
  props: ["getSchoolName", "submintLogin"],
  data() {
    return {
      schoolName: 2,
      checked: false,
      loginForm: {
        name: "",
        memberPassword: "",
      },
      LoginFormRules: {
        // 用户名验证
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          // { min: 3, max: 15, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        // login password  check
        memberPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    handleChange(e) {
      this.loginForm.name = e.replace(/\s*/g, "");
    },
    operation(e) {
      let type = e;
      this.$emit("operation", type);
    },
    submitForm() {
      if (this.checked === false) {
        this.$message.warning("请先勾选协议...");
        return;
      }
      this.$refs.loginFormRef.validate((value) => {
        if (value) {
          let login = JSON.stringify(this.loginForm);
          this.$emit("event", login);
        }
      });
    },
    //查看比赛规则事件
    jumpDetails(val) {
      // activeName
      this.$router.push({
        path: "/petiDetails",
        query: {
          state: val,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jums {
  width: 100%;
  transition: all 1s;
}
.moving {
  transform: translateX(20px);
}
.wx-login-box {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 901;
  .conten {
    width: 650px;
    height: 430px;
    background-color: #ffffff;
    z-index: 1000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 14upx;
    overflow: hidden;
    border-radius: 15px;
    .titl {
      width: 40%;
      height: inherit;
      float: left;
      background-image: url("../assets/logIn.png");
      background-size: 100% 100%;
    }
    .spacing {
      width: 60%;
      height: inherit;
      float: left;
      position: relative;
      .title-prompt {
        width: 50%;
        margin: 100px auto 0;
      }
      .el-form {
        width: 80%;
        margin: 0 auto;
      }
    }
  }
}
.el-divider__text {
  color: #2489fd;
  width: 100px;
  font-size: 19px !important;
}
.subutt {
  color: #ffffff;
  width: 100%;
  height: 40px;
  border: none;
  font-size: 17px;
  background: #2d80ff;
  cursor: pointer;
}
.close {
  color: #ffffff;
  position: absolute;
  top: 0px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}
.greement {
  width: 100%;
  text-align: left;
  padding-left: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 13px;
  background: #f5f5f5;
  span {
    color: #295bfa;
    cursor: pointer;
  }
}
</style>